import { render, staticRenderFns } from "./OfficalItem.vue?vue&type=template&id=275cad89&scoped=true"
import script from "./OfficalItem.vue?vue&type=script&lang=js"
export * from "./OfficalItem.vue?vue&type=script&lang=js"
import style0 from "./OfficalItem.vue?vue&type=style&index=0&id=275cad89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275cad89",
  null
  
)

export default component.exports